import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonDropdownComponent } from '../common-dropdawn/common-dropdown.component';
import { FormControl } from '@angular/forms';
import { Params } from '@angular/router';
import { GroupsSelectorService } from '../../services/groups-selector.service';

@Component({
    selector: 'app-group-selector',
    standalone: true,
    imports: [CommonModule, CommonDropdownComponent],
    templateUrl: './group-selector.component.html',
    styleUrl: './group-selector.component.scss'
})
export class GroupSelectorComponent implements OnInit{
    @Input({ required: true }) formCtrl!: FormControl;
    @Input() label: string | undefined;
    @Input() multiple = false;
    @Input() noneOption = true;
    @Input() additionalParams?: Params; // здесь можно будет задать фильтра для конкретной компании

    constructor(protected groupSelectorService: GroupsSelectorService) {}

    ngOnInit(): void {
        if (this.additionalParams) {
            this.groupSelectorService.additionalParams = this.additionalParams;
        }
    }
}
